import { wrapRequest } from '@applandeo/api-wrapper';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ALERT_VARIANT, useAlertMessages } from '@/components/Global/AlertMessages/AlertMessagesProvider';
import { getAllUsers } from '@/dataExchange/services/user.service';
import { UserDataResponse } from '@/domain/user';
import { useSentryActions } from '@/sentry/hooks/useSentryActions';
import { SENTRY_ACTIONS } from '@/sentry/sentryActions';
import { USER_STATUS } from '@/utils/enums/common';

export const useAllUsers = (status = USER_STATUS.ACTIVE) => {
    const { createAlert } = useAlertMessages();
    const { t } = useTranslation();
    const { handleSentryAction } = useSentryActions();
    const [allUsers, setAllUsers] = useState<UserDataResponse[]>();
    const getAllUsersWrapper = wrapRequest(getAllUsers);

    useEffect(() => {
        getAllUsersWrapper
            .fetch({ page: 1, pageSize: 1000, status })
            .onAnyError(error => {
                createAlert(ALERT_VARIANT.error, t('newRequest_alerts_failed_to_get_all_users'));
                handleSentryAction(error, SENTRY_ACTIONS.ERROR_GET_ALL_USERS);
            })
            .onSuccess(response => setAllUsers(response?.elements));
    }, [status]);

    return allUsers;
};
